module.exports = {"id":"190813","name":"Stephan El Shaarawy","rating":"81","photo":"./data/images/photos/1/190813.png","club":{"name":"AS Rome","logo":"./data/images/clubs/ASRome.png"},"positions":["AG","AD"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/StephanElShaarawy0.json
// module id = 4023
// module chunks = 0